export const TEST_ID = 'applicationsAccordion';
